export const ApckNarrativeMeta = {
    props: {
        timestamp: {
            type: Number,
            required: true,
        },
        verbosity: {
            type: String,
            default: '',
        },
        fileType: {
            type: String,
            default: null,
        },
    },
    computed: {
        formattedTimestamp() {
            return new Date(this.timestamp * 1000).toISOString().slice(0, 19).replace('T', ' ');
        },
        verbosityColour() {
            const map = {
                critical: 'red',
                error: 'red',
                warning: 'yellow',
                info: 'blue',
                debug: 'green'
            };
            return map[this.verbosity?.toLowerCase()] || 'light-slate';
        },
    },
    template: `
    <ui-layout align="center" gap="2">
        <i>{{ formattedTimestamp }}</i>
        <ui-badge v-if="verbosity" :label="verbosity.toLowerCase()" :color="verbosityColour" shadow data-verbosity="" />
        <ui-badge v-if="fileType" :label="fileType" color="light-slate" shadow />
    </ui-layout>
  `,
};
